import { Component, ViewChild, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { GoToStep } from '../../../../store/onboarding/onboarding.actions';
import { OnboardingSteps } from '../../../../store/onboarding/onboarding.model';
import { BoUploadsModule, UploadSettings } from '@bo/ng-uploads';
import { PaysCheckboxComponent } from '../../../../shared/components/forms/pays-checkbox/pays-checkbox.component';
import { RegisterService } from '../../../../_services/register-service/register.service';
import { UploadComponent } from '../../../../shared/components/upload/upload.component';
import { UploadFile } from 'ngx-uploader';
import { Router } from '@angular/router';
import { FileUploadComponent } from '../../../../shared/components/file-upload/file-upload.component';
import { ProfileDropdownComponent } from '../../../../shared/components/profile-dropdown/profile-dropdown.component';
import { returnSlashedPath, UploadedFileWithMeta } from '../../../../shared/utils/upload-utils';

@Component({
  selector: 'app-business-certificate',
  imports: [BoUploadsModule, PaysCheckboxComponent, UploadComponent, FileUploadComponent, ProfileDropdownComponent],
  templateUrl: './business-certificate.component.html',
})
export class BusinessCertificateComponent {
  readonly store = inject(Store);
  readonly registerService = inject(RegisterService);
  readonly router = inject(Router);

  @ViewChild('uploadRef') uploadComponent!: UploadComponent;
  documentUrl?: string;
  file?: UploadFile;
  uploadSettings: UploadSettings = {
    destination: 'certificates',
    fileOwner: { owner_id: '1', owner_type: 'USER' },
  };
  chkBoxValue: boolean = false;

  constructor() {
    this.store.dispatch(new GoToStep(OnboardingSteps.BUSINESS_CERTIFICATE));
  }

  documentUploaded($event: UploadedFileWithMeta) {
    this.documentUrl = returnSlashedPath($event.file);
    this.file = $event.file;
  }

  onChangeDocument($event: boolean) {
    if ($event) {
      this.documentUrl = undefined;
      this.file = undefined;
      this.uploadComponent?.reset();
    }
  }

  onSubmit() {
    if (this.documentUrl) {
      this.registerService.uploadBusinessCertificate(this.documentUrl).subscribe({
        next: () => {
          this.router.navigate(['/sign-up/verify-business'], { replaceUrl: true });
        },
      });
    }
  }

  disabledBtn() {
    return !this.chkBoxValue || this.documentUrl === undefined;
  }
}
